const apiConfig = {
  baseUrl: "https://api.themoviedb.org/3/",
  apiKey: "4a63461d35fd5dd671ad3fe50149e936",
  originalImage: (imgPath) => `https://image.tmdb.org/t/p/original/${imgPath}`,
  w500Image: (imgPath) => `https://image.tmdb.org/t/p/w500/${imgPath}`,
};

export default apiConfig;
